import type { Dispatch, SetStateAction } from 'react'

import type { OrderForm } from '../entity/orderForm'
import { addCartShippingData } from '../data/checkout/shippingData'

export const useShippingData = (
  orderForm: OrderForm,
  setOrderForm: Dispatch<SetStateAction<OrderForm>>
) => {
  const addShippingData = async (cep: string) => {
    const updatedOrderform = await addCartShippingData(
      orderForm.orderFormId,
      cep
    )

    setOrderForm(updatedOrderform)

    return updatedOrderform
  }

  return { addShippingData }
}
